import {useEffect, useState} from 'react';
import {getDownloadURL, ref} from 'firebase/storage';
import {firebaseStorage} from '../../config/firebase';

/**
 * Hook to convert a Firebase Storage file path to a downloadable URL
 * @param url - The Firebase Storage URL or regular URL
 * @returns The processed URL and loading state
 */
export default function useDownloadStorageFile(url?: string) {
  const [processedUrl, setProcessedUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadUrl = async () => {
      if (!url) {
        setProcessedUrl(null);
        return;
      }

      // If it's not a Firebase Storage URL, return as is
      if (!url.includes('firebasestorage.googleapis.com')) {
        setProcessedUrl(url);
        return;
      }

      try {
        setLoading(true);
        const fileRef = ref(firebaseStorage, url);
        const downloadUrl = await getDownloadURL(fileRef);
        setProcessedUrl(downloadUrl);
      } catch (err) {
        console.error('Error loading storage file:', err);
        setProcessedUrl(null);
      } finally {
        setLoading(false);
      }
    };

    loadUrl();
  }, [url]);

  return {url: url ? processedUrl || url : undefined, loading};
}
